module.exports = __webpack_public_path__ + "img/acediamonds.ebd6f2a0.png";